var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    [
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { attrs: { cols: "12", lg: "4", md: "4" } },
            [
              _c(
                "v-card",
                [
                  _c(
                    "v-toolbar",
                    {
                      attrs: {
                        color: _vm.editMode ? "yellow darken-3" : "primary",
                        dark: "",
                        dense: "",
                        flat: ""
                      }
                    },
                    [
                      _c("span", [
                        _vm._v(_vm._s(_vm.editMode ? "Edit" : "Create"))
                      ])
                    ]
                  ),
                  _c(
                    "v-container",
                    [
                      _c("create-duck-egg-collection", {
                        attrs: { "default-data": _vm.editDuckEggCollection },
                        on: {
                          "update:defaultData": function($event) {
                            _vm.editDuckEggCollection = $event
                          },
                          "update:default-data": function($event) {
                            _vm.editDuckEggCollection = $event
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "12", lg: "8", md: "8" } },
            [
              _c(
                "v-card",
                [
                  _c(
                    "v-toolbar",
                    {
                      attrs: { color: "primary", dark: "", dense: "", flat: "" }
                    },
                    [_c("span", [_vm._v("List")])]
                  ),
                  _c(
                    "v-container",
                    [
                      _c("table-duck-egg-collection", {
                        on: {
                          edit: item => {
                            _vm.editDuckEggCollection = item
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }